<template>
  <DatatableReportV3
    id="customer-equipment-table"
    ref="datatable"
    title="All Customer Equipment"
    download-url="/reports/equipment"
    :config="config"
    :source="source"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import EquipmentContextMenu from "@/Equipment/EquipmentContextMenu.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";
import store from "../vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    equipmentTypeFlag: {
      type: Boolean,
      default: false
    },
    warrantyFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // The default sort and orderData are positions, so they move with the
    // classification columns to stay on the same column.
    const classificationColumns = customerClassificationColumns();

    return {
      config: {
        responsive: true,
        order: [[12 + classificationColumns.length, "asc"]],
        columns: [
          ...classificationColumns,
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 18 },
          { data: "customer_phone", title: "Phone", responsivePriority: 16 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 19
          },
          {
            data: "address",
            responsivePriority: 20,
            className: "equipment-dt-address",
            filterName: "zipcode",
            orderable: false,
            searchable: false
          },
          {
            data: "membership_status",
            responsivePriority: 9,
            title: "Membership Status",
            orderData: 4 + classificationColumns.length,
            searchable: false
          },
          {
            data: "alpha_status",
            visible: false,
            searchable: false,
            responsivePriority: 21
          },
          {
            data: "equipment_name",
            responsivePriority: 2,
            title: "Equipment Name",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.equipment
          },
          {
            data: "install_location",
            responsivePriority: 7,
            title: "Location",
            searchable: false
          },
          {
            data: "manufacturer",
            responsivePriority: 6,
            filterName: "manufacturers"
          },
          {
            data: "equipment_type",
            responsivePriority: 5,
            title: "Equipment Type",
            filterName: "equipment_types",
            searchable: false
          },
          {
            data: "component_type",
            responsivePriority: 10,
            title: "Component Type",
            filterName: "component_types",
            searchable: false
          },
          {
            data: "model_number",
            title: "Model Number",
            responsivePriority: 3
          },
          {
            data: "serial_number",
            title: "Serial Number",
            responsivePriority: 4
          },
          {
            data: "manufacture_date",
            responsivePriority: 15,
            title: "Manufacture Date",
            searchable: false
          },
          {
            data: "installation_date",
            responsivePriority: 11,
            title: "Installation Date",
            filterName: "installed_on",
            searchable: false
          },
          {
            data: "last_service_date",
            responsivePriority: 12,
            title: "Last Service Date",
            searchable: false,
            visible: this.equipmentTypeFlag
          },
          {
            data: "age",
            responsivePriority: 8,
            title: "Age",
            filterName: "age_between",
            searchable: false
          },
          {
            data: "warranty",
            responsivePriority: 13,
            title: "Included Warranty",
            searchable: false
          },
          {
            data: "extended_warranty",
            responsivePriority: 14,
            title: "Extended Warranty",
            filterName: "warranty_programs",
            visible: this.warrantyFlag
          },
          {
            data: "equipment_notes",
            responsivePriority: 17,
            title: "Equipment Notes",
            searchable: false,
            orderable: false,
            createdCell(td, cellData) {
              if (cellData && cellData !== "--") {
                td.setAttribute("data-tippy-content", cellData);
                td.style.maxWidth = "200px";
                td.style.overflow = "hidden";
                td.style.textOverflow = "ellipsis";
                td.style.whiteSpace = "nowrap";
              }
            }
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "equipment-dt-actions text-center",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "equipment-context-menu-vue",
            component: EquipmentContextMenu,
            options: {
              store,
              listeners: { "save-success": this.refreshData }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "All Customer Equipment" });
  }
};
</script>

<style lang="scss">
.equipment-dt-actions {
  width: 50px;
  padding: 0;
  color: var(--lightblue) !important;
}
.equipment-dt-address {
  width: 200px;
}
#customer-equipment-table {
  overflow: visible;
  tr > td {
    vertical-align: baseline !important;
  }
}
</style>
